import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';
import { getCategoryBySlug } from '@/mocks/categories';

const articleImages: Record<string, string> = {
  '1': 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20colorful%20shopping%20app%20interface%20with%20warm%20ambient%20lighting%2C%20minimalist%20flat%20lay%20composition%20with%20soft%20pink%20and%20cream%20tones%2C%20clean%20product%20photography%20style%2C%20gentle%20natural%20light%20from%20window%2C%20elegant%20lifestyle%20aesthetic%20with%20subtle%20feminine%20touches&width=800&height=480&seq=article-1&orientation=landscape',
  '2': 'https://readdy.ai/api/search-image?query=A%20warm-toned%20customer%20service%20workspace%20setup%20with%20a%20laptop%20showing%20support%20chat%20interface%2C%20phone%20and%20headset%20on%20a%20clean%20desk%2C%20soft%20natural%20lighting%20through%20sheer%20curtains%2C%20minimalist%20and%20professional%20atmosphere%2C%20gentle%20pink%20and%20cream%20color%20palette%2C%20cozy%20and%20trustworthy%20brand%20aesthetic&width=800&height=480&seq=article-2&orientation=landscape',
  '3': 'https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20displaying%20a%20package%20tracking%20interface%20with%20delivery%20route%20map%2C%20placed%20on%20a%20clean%20wooden%20desk%20with%20a%20cup%20of%20tea%20nearby%2C%20warm%20natural%20morning%20light%2C%20minimalist%20lifestyle%20composition%2C%20soft%20beige%20and%20cream%20tones%2C%20calm%20and%20organized%20atmosphere%2C%20product%20photography%20style&width=800&height=480&seq=article-3&orientation=landscape',
  '4': 'https://readdy.ai/api/search-image?query=A%20diverse%20group%20of%20smartphones%20and%20tablets%20displaying%20various%20social%20media%20app%20icons%20on%20their%20screens%2C%20arranged%20on%20a%20warm%20cream-colored%20surface%2C%20soft%20diffused%20lighting%20creating%20gentle%20shadows%2C%20modern%20community%20connection%20concept%2C%20clean%20and%20aspirational%20lifestyle%20aesthetic%2C%20pastel%20pink%20and%20warm%20beige%20tones%2C%20editorial%20flat%20lay%20photography&width=800&height=480&seq=article-4&orientation=landscape',
  '5': 'https://readdy.ai/api/search-image?query=A%20vibrant%20shopping%20promotion%20flat%20lay%20with%20gift%20boxes%2C%20discount%20tags%2C%20and%20shopping%20bags%20in%20soft%20pastel%20pink%20and%20gold%20tones%2C%20elegant%20and%20festive%20composition%2C%20warm%20ambient%20lighting%20with%20gentle%20sparkle%20accents%2C%20luxury%20retail%20aesthetic%2C%20clean%20and%20celebratory%20atmosphere%2C%20modern%20e-commerce%20lifestyle%20photography&width=800&height=480&seq=article-5&orientation=landscape',
  '6': 'https://readdy.ai/api/search-image?query=A%20clean%20and%20organized%20desk%20setup%20with%20a%20return%20package%20and%20shipping%20label%20ready%20to%20be%20sent%2C%20surrounded%20by%20packing%20materials%20and%20tape%20dispenser%2C%20soft%20window%20light%20creating%20a%20calm%20atmosphere%2C%20minimalist%20e-commerce%20logistics%20concept%2C%20warm%20beige%20and%20cream%20tones%2C%20trustworthy%20and%20reassuring%20brand%20aesthetic%2C%20editorial%20product%20photography&width=800&height=480&seq=article-6&orientation=landscape',
};

export default function HomeArticles() {
  const latestArticles = getLatestArticles(6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              最新动态
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base">
              关注蜜芽最新资讯，永不失联
            </p>
          </div>
          <Link
            to="/category/zui-xin-dong-tai"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {latestArticles.map((article) => {
            const cat = getCategoryBySlug(article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-white rounded-lg overflow-hidden transition-all hover:-translate-y-1 cursor-pointer"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={articleImages[article.id] || articleImages['1']}
                    alt={article.title}
                    title={`${article.title} - 蜜芽永不失联`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-4 md:p-5">
                  <div className="flex items-center gap-3 mb-2">
                    {cat && (
                      <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                        {cat.name}
                      </span>
                    )}
                    <span className="text-xs text-foreground-500">{article.date}</span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {article.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 mt-2 line-clamp-2">
                    {article.summary}
                  </p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}